// extracted by mini-css-extract-plugin
export default {"wrapper":"qD-z","addressLine":"rD-z","fullName":"sD-z"};